export default "__VITE_ASSET__Y4xdW1LK__"